<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-checkbox
                v-if="showTrashedCheckbox"
                class="pt-5 mr-5"
                v-model="showTrashed"
                label="Afisare informatiile sterse"
            />
            <search-field v-model="search"></search-field>
            <v-btn
                v-if="hasAddNewButton"
                color="primary"
                dark
                class="ml-2"
                @click="addNewItem"
            >
                Adaugare
            </v-btn>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.type="{ item }">
                {{ item.friendlyType }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | date }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Produse si servicii',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Tip', value: 'type' },
                { text: 'Denumire', value: 'name' },
                { text: 'Cod produs', value: 'product_number' },
                { text: 'Descriere', value: 'description' },
                { text: 'Data adaugarii', value: 'created_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            showTrashedCheckbox: true,
            showTrashed: false
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.Product
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'products-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Product) {
                    await item.delete().catch((err) => {
                        this.showError(err?.response?.data?.error)
                        throw err
                    })
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'products-create' })
            },
        },
    };
</script>
